(() => {
  if (window.orionHomeInitialized) return;
  window.orionHomeInitialized = true;
  const desktopMenu = window.matchMedia('(min-width: 761px)');
  const closeTimers = new WeakMap();
  const closeMobileMenu = header => {
    if (!header) return;
    header.classList.remove('is-menu-open');
    document.body.classList.remove('orion-menu-open');
    const toggle = header.querySelector('.oh-menu-toggle');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
    }
    header.querySelectorAll('.oh-dropdown[open]').forEach(item => { item.open = false; });
  };
  document.addEventListener('pointerover', event => {
    if (!desktopMenu.matches) return;
    const dropdown = event.target.closest('.oh-dropdown');
    if (!dropdown) return;
    document.querySelectorAll('.oh-dropdown[open]').forEach(item => {
      if (item !== dropdown) item.open = false;
    });
    window.clearTimeout(closeTimers.get(dropdown));
    dropdown.open = true;
  });
  document.addEventListener('pointerout', event => {
    if (!desktopMenu.matches) return;
    const dropdown = event.target.closest('.oh-dropdown');
    if (!dropdown || dropdown.contains(event.relatedTarget)) return;
    const timer = window.setTimeout(() => {
      if (!dropdown.matches(':hover') && !dropdown.contains(document.activeElement)) dropdown.open = false;
    }, 80);
    closeTimers.set(dropdown, timer);
  });
  document.addEventListener('click', event => {
    const cartTrigger = event.target.closest('[data-orion-cart-trigger]');
    if (cartTrigger) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.open) {
        event.preventDefault();
        closeMobileMenu(cartTrigger.closest('.oh-site-header'));
        drawer.open(cartTrigger);
      }
      return;
    }
    const toggle = event.target.closest('.oh-menu-toggle');
    if (toggle) {
      const header = toggle.closest('.oh-site-header');
      const opened = header.classList.toggle('is-menu-open');
      document.body.classList.toggle('orion-menu-open', opened);
      toggle.setAttribute('aria-expanded', String(opened));
      toggle.setAttribute('aria-label', opened ? 'Close menu' : 'Open menu');
      if (!opened) header.querySelectorAll('.oh-dropdown[open]').forEach(item => { item.open = false; });
      return;
    }
    const backdrop = event.target.closest('.oh-menu-backdrop');
    if (backdrop) {
      closeMobileMenu(backdrop.closest('.oh-site-header'));
      return;
    }
    const mobileLink = event.target.closest('.oh-menu a');
    if (mobileLink && !desktopMenu.matches) {
      closeMobileMenu(mobileLink.closest('.oh-site-header'));
      return;
    }
    document.querySelectorAll('.oh-dropdown[open]').forEach(dropdown => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const header = event.target.closest('.oh-site-header');
    if (!header) return;
    header.querySelectorAll('details[open]').forEach(d => { d.open = false; });
    closeMobileMenu(header);
    const toggle = header.querySelector('.oh-menu-toggle');
    if (getComputedStyle(toggle).display !== 'none') toggle.focus();
  });
  desktopMenu.addEventListener('change', event => {
    if (!event.matches) return;
    document.querySelectorAll('.oh-site-header.is-menu-open').forEach(closeMobileMenu);
  });
})();

/* Shared review carousel controls for home, collection and product templates. */
(() => {
  const selector = '.oh-review-track, .oc-review-track, .op-review-cards';

  const initReviewCarousel = track => {
    if (!track || track.dataset.orionCarouselReady === 'true') return;
    track.dataset.orionCarouselReady = 'true';
    track.classList.add('orion-review-carousel');
    track.tabIndex = 0;

    const shell = document.createElement('div');
    shell.className = 'orion-review-carousel-shell';
    track.parentNode.insertBefore(shell, track);
    shell.appendChild(track);

    const controls = document.createElement('div');
    controls.className = 'orion-review-carousel-controls';
    controls.innerHTML = '<button type="button" class="orion-review-carousel-arrow orion-review-carousel-arrow--prev" aria-label="Previous reviews">&#8249;</button><button type="button" class="orion-review-carousel-arrow orion-review-carousel-arrow--next" aria-label="Next reviews">&#8250;</button>';
    shell.appendChild(controls);

    const previous = controls.querySelector('.orion-review-carousel-arrow--prev');
    const next = controls.querySelector('.orion-review-carousel-arrow--next');
    const cards = () => Array.from(track.children);
    const scrollStep = () => {
      const first = cards()[0];
      if (!first) return Math.max(track.clientWidth * .82, 260);
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    };
    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const overflow = max > 3;
      shell.classList.toggle('has-overflow', overflow);
      previous.disabled = !overflow || track.scrollLeft <= 3;
      next.disabled = !overflow || track.scrollLeft >= max - 3;
    };

    previous.addEventListener('click', () => track.scrollBy({ left: -scrollStep(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: scrollStep(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      track.scrollBy({ left: event.key === 'ArrowLeft' ? -scrollStep() : scrollStep(), behavior: 'smooth' });
    });

    let activePointerId = null;
    let activePointerType = '';
    let startX = 0;
    let startY = 0;
    let lastX = 0;
    let startScroll = 0;
    let dragging = false;
    let moved = false;
    const beginDragging = event => {
      dragging = true;
      track.classList.add('is-dragging');
      try { track.setPointerCapture(event.pointerId); } catch (error) { /* Capture is optional. */ }
    };
    track.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (activePointerId !== null) return;
      activePointerId = event.pointerId;
      activePointerType = event.pointerType;
      moved = false;
      startX = event.clientX;
      startY = event.clientY;
      lastX = event.clientX;
      startScroll = track.scrollLeft;
      if (event.pointerType === 'mouse') beginDragging(event);
    });
    track.addEventListener('pointermove', event => {
      if (event.pointerId !== activePointerId) return;
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      lastX = event.clientX;
      if (!dragging) {
        if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 6) return;
        if (Math.abs(deltaY) >= Math.abs(deltaX)) {
          activePointerId = null;
          activePointerType = '';
          return;
        }
        beginDragging(event);
      }
      if (Math.abs(deltaX) > 4) moved = true;
      if (event.cancelable) event.preventDefault();
      track.scrollLeft = startScroll - deltaX;
    }, { passive: false });
    const stopDragging = event => {
      if (event.pointerId !== activePointerId) return;
      const wasDragging = dragging;
      const pointerType = activePointerType;
      const swipeDistance = startX - lastX;
      dragging = false;
      activePointerId = null;
      activePointerType = '';
      track.classList.remove('is-dragging');
      try {
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      } catch (error) { /* Capture may already have been released. */ }
      if (wasDragging && pointerType !== 'mouse') {
        const step = scrollStep();
        const cardCount = Math.max(1, Math.round(Math.abs(swipeDistance) / step));
        const direction = Math.abs(swipeDistance) > 22 ? Math.sign(swipeDistance) : 0;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const target = Math.min(max, Math.max(0, startScroll + direction * cardCount * step));
        requestAnimationFrame(() => track.scrollTo({ left: target, behavior: 'smooth' }));
      }
    };
    track.addEventListener('pointerup', stopDragging);
    track.addEventListener('pointercancel', stopDragging);
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('click', event => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);

    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    requestAnimationFrame(update);
    setTimeout(update, 250);
  };

  const initAllReviewCarousels = root => {
    if (root.matches?.(selector)) initReviewCarousel(root);
    root.querySelectorAll?.(selector).forEach(initReviewCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllReviewCarousels(document));
  } else {
    initAllReviewCarousels(document);
  }
  document.addEventListener('shopify:section:load', event => initAllReviewCarousels(event.target));
})();
